import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import Logo from './partials/Logo';
import * as data from '../../Lokesh_Profile.json'
const propTypes = {
  navPosition: PropTypes.string,
  hideNav: PropTypes.bool,
  hideSignin: PropTypes.bool,
  bottomOuterDivider: PropTypes.bool,
  bottomDivider: PropTypes.bool
}

const defaultProps = {
  navPosition: '',
  hideNav: false,
  hideSignin: false,
  bottomOuterDivider: false,
  bottomDivider: false
}

const Header = ({
  className,
  navPosition,
  hideNav,
  hideSignin,
  bottomOuterDivider,
  bottomDivider,
  ...props
}) => {

  const [isActive, setIsactive] = useState(false);

  const nav = useRef(null);
  const hamburger = useRef(null);
const shortname = data.info[0].shortname
  const location = useLocation();  
  useEffect(() => {
console.log('theh path = '+location.pathname)
    isActive && openMenu();
    document.addEventListener('keydown', keyPress);
    document.addEventListener('click', clickOutside);
    return () => {
      document.removeEventListener('keydown', keyPress);
      document.addEventListener('click', clickOutside);
      closeMenu();
    };
  });  

  const openMenu = () => {
    document.body.classList.add('off-nav-is-active');
    nav.current.style.maxHeight = nav.current.scrollHeight + 'px';
    setIsactive(true);
  }
// When the user scrolls the page, execute myFunction 
window.onscroll = function() {myFunction()};

function myFunction() {
  var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  var scrolled = (winScroll / height) * 100;
  document.getElementById("myBar").style.width = scrolled + "%";
}
  const closeMenu = () => {
    document.body.classList.remove('off-nav-is-active');
    nav.current && (nav.current.style.maxHeight = null);
    setIsactive(false);
  }

  const keyPress = (e) => {
    isActive && e.keyCode === 27 && closeMenu();
  }

  const clickOutside = (e) => {
    if (!nav.current) return
    if (!isActive || nav.current.contains(e.target) || e.target === hamburger.current) return;
    closeMenu();
  }  

  const classes = classNames(
    'site-header',
    bottomOuterDivider && 'has-bottom-divider',
    className
  );

  return (
    <div>
      <div style={{position:'fixed',top:0,zIndex:1,width:'100%'}}>
       <div style={{width:'100%',height:'8px'}}  class="progress-container">
          <div style={{height:'8px',background:'#4ca50', width:'0%'}} class="progress-bar" id="myBar"></div>
      </div> 
    </div> 
    <header
      {...props}
      className={classes}
    >
      <div>

      <div className="container">
     
        <div 
        className={
          classNames(
            'site-header-inner',
            bottomDivider && 'has-bottom-divider'
          )}>
            
            {location.pathname !== '/'?
            
            <> <Logo /> <span style={{fontSize:'xx-large', fontWeight:900, color:'white'}}>{shortname}</span> </> : <span></span>
          }
          {!hideNav &&
            <>
              <button
                style={{marginLeft:'40px'}}
                ref={hamburger}
                className="header-nav-toggle"
                onClick={isActive ? closeMenu : openMenu}
              >
                <span className="screen-reader">Menu</span>
                <span className="hamburger">
                  <span className="hamburger-inner"></span>
                </span>
              </button>
              <nav
                ref={nav}
                className={
                  classNames(
                    'header-nav',
                    isActive && 'is-active'
                  )}>
                <div className="header-nav-inner">
                  <ul className={
                    classNames(
                      'list-reset text-xs',
                      navPosition && `header-nav-${navPosition}`
                    )}>
                    {location.pathname == '/' ?
                  <li>
                  <Link style={{color:'cornflowerblue'}} to="/" onClick={closeMenu}>Home</Link>
                  </li>
:
                  <li>
                      <Link to="/" onClick={closeMenu}>Home</Link>
                  </li>

                  }
                    {location.pathname == '/educationandexp' ?
                          <li>
                          <Link style={{color:'cornflowerblue'}} to="educationandexp" onClick={closeMenu}>Education & Experience</Link>
                          </li>:             
                    <li>
                      <Link to="educationandexp" onClick={closeMenu}>Education & Experience</Link>
                    </li>
}
                    {/* <li>
                      <Link to="#1" onClick={closeMenu}>Projects</Link>
                    </li> */}
                    {location.pathname == '/contact' ?
                    <li>
                    <Link style={{color:'cornflowerblue'}} to="contact" onClick={closeMenu}>Contact</Link>
                    </li>: 
                    <li>
                      <Link to="contact" onClick={closeMenu}>Contact</Link>
                    </li>
}
                  </ul>
                  {/* {!hideSignin &&
                    <ul
                      className="list-reset header-nav-right"
                    >
                      <li>
                        <Link to="#0" className="button button-primary button-wide-mobile button-sm" onClick={closeMenu}>Sign up</Link>
                      </li>
                    </ul>} */}
                </div>
              </nav>
            </>}
        </div>
      </div>
      </div>
    </header>
    </div>
  );
}

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;